module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<ul class="mdl_menu_mobile__nav-sub-items">\n\n    ';
 const renderLink = ( item, hasSubmenu = false, idx = 0 ) => {

        const itemClass = [ 'mdl_menu_mobile__item' ];
        const itemStyle = {};

        if ( hasSubmenu ) {
            itemClass.push( 'mdl_menu_mobile__item--has-submenu' );
        }

        if ( item.icon ) {
            itemClass.push( 'mdl_menu_mobile__item--has-icon' );
        }

        if ( item.expert_style ) {

            if ( item.expert_style.includes( 'highlight' ) ) {
                itemClass.push( 'mdl_menu_mobile__item--highlight' );
            }
            if ( item.expert_style.includes( 'bold' ) ) {
                itemClass.push( 'en_format_bold' );
            }
            if ( item.expert_style.includes( 'italic' ) ) {
                itemClass.push( 'en_format_italic' );
            }
            if ( item.expert_style.includes( 'underline' ) ) {
                itemClass.push( 'en_format_link' );
            }
        }

        if ( item.className ) {
            itemClass.push( [].concat( item.className ).join( ' ' ) );
        }

    
__p+='\n        <li class="'+
((__t=( itemClass.join( ' ' ) ))==null?'':__t)+
'"'+
((__t=( hasSubmenu ? `data-menu-index="${idx}"` : '' ))==null?'':__t)+
''+
((__t=( item.color ? ` style="color:${item.color}"` : '' ))==null?'':__t)+
'>\n            <a class="mdl_menu_mobile__item-link" '+
((__t=( getLinkProps( item.link ) ))==null?'':__t)+
'>\n                <span class="mdl_menu_mobile__item-inner'+
((__t=( item.icon ? ' en_icon' : '' ))==null?'':__t)+
' " '+
((__t=( item.icon ? `data-en-icon="${item.icon}"` : '' ))==null?'':__t)+
'>'+
((__t=( item.link.title ))==null?'':__t)+
'</span>\n            </a>\n        </li>\n    ';
 } 
__p+='\n\n    ';
 const renderImage = ( item, idx = 0 ) => {
        if ( ! item.image ) {
            return;
        }

        const [src, width, height] = item.image;
        const itemClass = [ 'mdl_menu_mobile__item' ];

        if ( src ) {
            itemClass.push( 'mdl_menu_mobile__item--image' );
        }

    
__p+='\n        <li class="'+
((__t=( itemClass.join( ' ' ) ))==null?'':__t)+
'">\n            <a class="mdl_menu_mobile__item-link" '+
((__t=( getLinkProps( item.link ) ))==null?'':__t)+
' >\n                <figure class="mdl_menu_mobile__item-inner">\n                    <img src="'+
((__t=( src ))==null?'':__t)+
'" width="'+
((__t=( width ))==null?'':__t)+
'" height="'+
((__t=( height ))==null?'':__t)+
'" />\n                </figure>\n            </a>\n        </li>\n    ';
 } 
__p+='\n\n    ';
 const renderItem = ( item, hasSubmenu = false, idx = 0 ) => {
        if ( 'image' in item ) {
            renderImage( item, idx );
        } else {
            renderLink( item, hasSubmenu, idx );
        }
    } 
__p+='\n\n    ';
 if ( all ) {
        renderLink( {
            link: all,
            expert_style:[ 'highlight' ],
        } )
    } 
__p+='\n\n    ';


    if ( item && item.link && item.link.title ) {
        const hasSubmenu = menu && menu.length > 0;

        renderItem( item, hasSubmenu );
    } else if ( menu ) {

        Object.values( menu || [] ).forEach( function( submenu, idx ) {
            const subItem = submenu.item;
            const hasSubLink = subItem.link?.title;
            const hasSubmenu = submenu.menu && submenu.menu.length > 0;

            if ( ! hasSubLink && hasSubmenu ) {

                if ( submenu.all ) {

                    renderLink( {
                        link: submenu.all,
                        expert_style:[ 'highlight' ],
                    } );
                }

                Object.values( submenu.menu || [] ).forEach( function( subSubmenu, jdx ) {

                    const subSubItem = subSubmenu.item;
                    const hasSubSubmenu = subSubmenu.menu && subSubmenu.menu.length > 0;

                    renderItem( subSubItem, hasSubSubmenu, idx + '-' + jdx );
                } )

            } else {
                renderItem( subItem, hasSubmenu, idx );
            }
        } );
    }
    
__p+='\n</ul>\n';
}
return __p;
};
